import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {WebsiteCarouselArticlesFeaturedComponent} from './website-carousel-articles-featured.component'
import {BrowserModule} from '@angular/platform-browser'
import {BrowserAnimationsModule} from '@angular/platform-browser/animations'
import {SharedModule} from '../shared/shared.module'
import {NgbNavModule} from '@ng-bootstrap/ng-bootstrap'
import {CarouselModule} from 'ngx-owl-carousel-o'
import {PipesModule} from '../../pipes/pipes.module'
import {RouterModule} from '@angular/router'

@NgModule({
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    CommonModule,
    SharedModule,
    NgbNavModule,
    CarouselModule,
    PipesModule,
    RouterModule
  ],
  declarations: [WebsiteCarouselArticlesFeaturedComponent],
  exports: [
    WebsiteCarouselArticlesFeaturedComponent
  ],
  providers: []
})
export class WebsiteCarouselArticlesFeaturedModule {
}
